export default __webpack_public_path__ + "static/media/bg6.5a89a9bd.png";